import React from 'react';
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import * as dateTime from "../../helpers/dateTime";
import { logUI } from '../../api/andyliticsApi';
import Spinner from "../common/spinner";
import NotAuthorized from '../common/NotAuthorized';
import StatusBanner from '../common/StatusBanner';
import PledgeTile from './PledgeTile';
import EarnPointsTile from './EarnPointsTile';
import WellBeingScoreTile from './WellBeingScoreTile';
import CoachingTile from './CoachingTile';
import WellnessGoals from './WellnessGoals';
import SectionLoadingError from "../common/SectionLoadingError";
import PreventiveCareExamTile from './PreventiveCareExamTile';
import ActionPlanTile from './ActionPlanTile';

class WellBeingDashboard extends React.Component {


    constructor(props) {
        super(props);

        const { wellnessDueDate } = this.props.serverData;
        //let qValues = this.props.location && this.props.location.search && queryString.parse(this.props.location.search);
        //const currentYear = qValues && qValues.year ? parseInt(qValues.year) : new Date(wellnessDueDate).getFullYear();
        const currentYear = new Date(wellnessDueDate).getFullYear();
        this.state = { tryAgain: false, currentYear: currentYear };
    }

    componentDidMount() {
        this.props.getWellnessReportV2(this.props.userToken, this.state.currentYear);
        logUI("MBHWeb.UI.WellBeingDashboard.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    tryAgain = (e) => {
        e.preventDefault();
        this.setState({ tryAgain: true });
        logUI("MBHWeb.UI.WellnessReport.onTryAgain", new Date(), Tools.getURLPath());
    }

    render() {
        const { hasMyChartLogin, dcjSelfOrderFailure, isProxyUser, serverData } = this.props;
        const { tryAgain, currentYear } = this.state;
        const wellnessDueDate = serverData && serverData.wellnessDueDate ? dateTime.formatDate(serverData.wellnessDueDate) : 'NA' ;


        return (            
            isProxyUser ? <NotAuthorized /> : <div className={`container-fluid body-content full-width${dcjSelfOrderFailure && !tryAgain ? " wellness-report-error-container" : " wellness-dashboard-container"}`}>

                {this.props.reportPending === true ? <Spinner /> :
                    dcjSelfOrderFailure && !tryAgain ? <div className="row"><div className="col-12">
                        <StatusBanner bannerMsg="Sorry, we are unable to start the journey." failedStatus>
                            <span>Please <Link to="/wellbeingDashboard" onClick={e => this.tryAgain(e)}>try again</Link> later.</span>
                        </StatusBanner>
                    </div>
                    </div> :
                        (this.props.reportError ?
                            <SectionLoadingError message="Sorry, we are not able to display your report. Please try again later." />
                            :
                            this.props.reportSuccess === true &&

                            <>
                                {/*!hasMyChartLogin ?
                                    <SectionLoadingError message="This feature is currently being tested with BSWH Employee Core Champions. If you are seeing this message, you don't have required medical record linkage. More information will be available soon." />
                                    :*/
                                    <div className="row">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row" >
                                                <div className="col-md-8 col-12">
                                                    <h1 className="page-heading">Well-being Dashboard</h1>
                                                    <p className="description">Complete your Well-being Assessment and earn 365 Thrive points by <b>{wellnessDueDate}</b> to avoid a $40 per pay period surcharge.</p>
                                                </div>
                                            </div>
                                            <div className="row" >
                                                <div className="col-sm-8 col-12">
                                                    <WellBeingScoreTile currentYear={currentYear} />
                                                    <PledgeTile currentYear={currentYear} />
                                                    <div className="card wellness-goal-tile">
                                                        <WellnessGoals currentYear={currentYear} isWellBeingDashboard={true}/>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 col-12">
                                                    <EarnPointsTile />
                                                    <PreventiveCareExamTile />
                                                    <CoachingTile />
                                                    <ActionPlanTile currentYear={currentYear} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>

                        )}
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        hasMyChartLogin: state.domain.hm,
        report: state.thrive.report,
        reportPending: state.thrive.reportPending,
        reportSuccess: state.thrive.reportSuccess,
        reportError: state.thrive.reportError,
        userToken: state.domain.t,
        dcjSelfOrderPending: state.dashboard.dcjSelfOrderPending,
        dcjSelfOrderSuccess: state.dashboard.dcjSelfOrderSuccess,
        dcjSelfOrderFailure: state.dashboard.dcjSelfOrderFailure,
        isProxyUser: state.domain.ip,
        serverData: state.session.serverData,
        ...ownProps
        
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWellnessReportV2: (token, reportYear) => {
            dispatch({ type: types.THRIVE_GET_REPORT, token, reportYear });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WellBeingDashboard));